import React, { Component } from 'react'
import PropTypes from 'prop-types'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import fullstory from '../../../../utils/constants/fullstory'

class CopyInviteLinkCard extends Component {
  static propTypes = {
    insToken: PropTypes.string,
    onClose: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.copyTextToClipboard = () => {
      try {
        document.querySelector('#linktxt').select()
        document.execCommand('copy')
        notificationsUtils.showSuccessNotification('Link Copied!')
      } catch (error) {
        notificationsUtils.error('Error in copying link. Please try again.')
      }
    }
  }

  render() {
    const { insToken, onClose } = this.props

    const inviteLink = `${process.env.REACT_APP_HOSTNAME}/signup?insToken=ST${insToken.substring(
      2,
    )}`

    return (
      <div style={{ position: 'relative' }}>
        <i
          className="fal fa-times"
          style={{ position: 'absolute', right: 0, top: -30, fontSize: 20, cursor: 'pointer' }}
          onClick={() => onClose()}
        />
        <div style={{ marginTop: 10 }}>
          <input
            id="linktxt"
            style={{ color: '#576671' }}
            className={`form-control ${fullstory.classNames.textInput}`}
            type="text"
            value={inviteLink}
            readOnly
          />
          <div className="text-center">
            <button className="btn btn-link" onClick={() => this.copyTextToClipboard()}>
              Copy Invite Link
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default CopyInviteLinkCard



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/CopyInviteLinkCard.js